import { ref } from "vue";

export function useCamera() {
  const cameraStream = ref(null);
  const isCameraActive = ref(false);
  const videoElement = ref(null);
  const canvasElement = ref(null);
  const selfiePreview = ref(null);

  const activateCamera = async () => {
    try {
      cameraStream.value = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "user",
          width: { ideal: 640 },
          height: { ideal: 480 },
        },
      });

      if (videoElement.value) {
        videoElement.value.srcObject = cameraStream.value;
      }
      isCameraActive.value = true;
    } catch (error) {
      console.error("Error al acceder a la cámara:", error);
      throw new Error("No se pudo acceder a la cámara");
    }
  };

  const takeSelfie = () => {
    return new Promise((resolve) => {
      const canvas = canvasElement.value;
      const video = videoElement.value;
      const context = canvas.getContext("2d");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0);

      canvas.toBlob(
        (blob) => {
          const preview = canvas.toDataURL("image/jpeg", 0.8);
          selfiePreview.value = preview;
          stopCamera();
          resolve({ blob, preview });
        },
        "image/jpeg",
        0.8
      );
    });
  };

  const stopCamera = () => {
    if (cameraStream.value) {
      cameraStream.value.getTracks().forEach((track) => track.stop());
      cameraStream.value = null;
      isCameraActive.value = false;
    }
  };

  const retakeSelfie = () => {
    selfiePreview.value = null;
  };

  const setSelfiePreview = (preview) => {
    selfiePreview.value = preview;
  };

  return {
    cameraStream,
    isCameraActive,
    videoElement,
    canvasElement,
    selfiePreview,
    activateCamera,
    takeSelfie,
    stopCamera,
    retakeSelfie,
    setSelfiePreview,
  };
}
